import { Row, Col, Form, Input, Radio, AutoComplete, Select } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { RadioChangeEvent } from 'antd/lib';
import RoleBasedAuth from 'apis/RoleBasedAPI';
import { AddFillIcon, AddIcon, Remove, XFillIcon } from 'assets/svg';
import Button from 'components/Button';
import { useUser } from 'contexts/User';
import { IUser } from 'interface/user.interface';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';

interface IProps {
  id: string;
  form: any;
}

const ApproveCartDetail = (props: IProps): JSX.Element => {
  const { id, form } = props;
  // const { user } = useUser();
  const [users, setUsers] = useState<IUser[]>([]);

  const { mutate: getUser } = useMutation(RoleBasedAuth.getUsers, {
    onSuccess: (response) => {
      const values = form.getFieldsValue();
      const filteredFields = Object.keys(values).filter((key) =>
        key.includes('emails_' + id.split('_')[0])
      );
      const valuesArray = filteredFields.reduce(
        (acc, key) => acc.concat(values[key]),
        []
      );
      const resultArray = response.data.filter(
        (item) => !valuesArray.some((email) => email === item.email)
      );

      setUsers(resultArray);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div style={{ marginLeft: '20px' }}>
      {/* <Col className="gutter-row" span={12}>
        <Form.Item name={'approve_type_' + id}>
          <Radio.Group defaultValue={0}>
            <Radio value={0}>Duyệt tuần tự</Radio>
            <Radio value={1}>Duyệt đồng cấp</Radio>
          </Radio.Group>
        </Form.Item>
      </Col> */}

      <Form.List name={'emails_' + id} initialValue={[undefined]}>
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field, index) => {
              return (
                <Form.Item
                  label={'Email người phê duyệt'}
                  required={false}
                  key={field.key}
                  style={{ marginBottom: '0px' }}
                >
                  <Row>
                    <Col span={10}>
                      <Form.Item
                        {...field}
                        //  name={field.name}
                      >
                        <Select
                          placeholder="Nhập email"
                          showSearch
                          options={
                            users == null || users == undefined
                              ? []
                              : id.split('')[0] === '1'
                              ? users
                                  // .filter((item) => item.email !== user?.email)
                                  .map((item: any) => ({
                                    label:
                                      item.fullName + ' - ' + item.jobTitle,
                                    value: item.email,
                                  }))
                              : users.map((item: any) => ({
                                  label: item.fullName + ' - ' + item.jobTitle,
                                  value: item.email,
                                }))
                          }
                          onSearch={(value) => {
                            getUser({ email: value });
                          }}
                          onBlur={(value) => {
                            setUsers([]);
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col style={{ marginLeft: '8px', marginTop: '2px' }}>
                      {index == 0 ? (
                        <Button
                          bgColor={'bg-white'}
                          border={'border-neutral-90'}
                          customClass={'no-show'}
                          onClick={add}
                        >
                          <AddFillIcon />
                        </Button>
                      ) : (
                        <Button
                          bgColor={'bg-white'}
                          border={'border-neutral-90'}
                          customClass={'no-show'}
                          onClick={() => remove(field.name)}
                        >
                          <Remove />
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Form.Item>
              );
            })}
            {/* <Form.Item>
              <Button
                bgColor={'bg-white'}
                border={'border-neutral-90'}
                customClass={'no-show'}
                onClick={add}
              >
                <AddFillIcon />
              </Button>
            </Form.Item> */}
          </>
        )}
      </Form.List>
    </div>
  );
};

export default ApproveCartDetail;
